// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__D-Zgq","title":"Footer_title__Y6TJE","wrapper":"Footer_wrapper__FRBwe","info":"Footer_info__zrKPQ","copyright":"Footer_copyright__lEVs3"};